import { render } from "./FAQ.vue?vue&type=template&id=a1000540&scoped=true"
import script from "./FAQ.vue?vue&type=script&lang=js"
export * from "./FAQ.vue?vue&type=script&lang=js"

import "./FAQ.vue?vue&type=style&index=0&id=a1000540&lang=scss&scoped=true"
import "./FAQ.vue?vue&type=style&index=1&id=a1000540&lang=css"

import exportComponent from "F:\\ei-projects\\ei-adult-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1000540"]])

export default __exports__